import Vue from 'vue';
import Router from 'vue-router';
import { getCookie } from '@/utils';
import { Message } from 'element-ui';

//登录框不展示右上角关闭
window.loginRegisterHideClose = true;

Vue.use(Router);

export const fixedRoutes = [
  //进入页
  {
    path: '/:flag/entry',
    name: 'Entry',
    component: () => import('@/views/Entry/index2024')
  },
  //练习首页
  {
    path: '/:flag/mockExam',
    name: 'MockExam',
    component: () => import('@/views/MockExam/index2024'),
    redirect: '/:flag/mockExam/examSystem',
    children: [
      {
        path: 'examSystem',
        name: 'examSystem',
        meta: { title: '考试系统' },
        component: () => import('@/views/MockExam/examSystem2024')
      },
      {
        path: 'examRecord',
        name: 'examRecord',
        meta: { title: '考试记录' },
        component: () => import('@/views/MockExam/examRecord2024')
      },
      {
        path: 'examChapter',
        name: 'examChapter',
        meta: { title: '按章练习' },
        component: () => import('@/views/MockExam/examChapter')
      },
      {
        path: 'chapterRecord',
        name: 'chapterRecord',
        meta: { title: '练习记录' },
        component: () => import('@/views/MockExam/chapterRecord')
      },
      {
        path: 'mistakeRecord',
        name: 'mistakeRecord',
        meta: { title: '错题记录' },
        component: () => import('@/views/MockExam/mistakeRecord2024')
      },
      {
        path: "collectRecord",
        name: "collectRecord",
        meta: {title: "收藏记录"},
        component: () => import("@/views/MockExam/collectRecord")
      }
    ]
  },
  //注会考试说明步骤
  {
    path: '/:flag/realMockExam',
    name: 'RealMockExam',
    component: () => import('@/views/RealMockExam'),
    redirect: '/:flag/realMockExam/step1',
    children: [
      {
        path: 'step1',
        name: 'Step1',
        component: () => import('@/views/RealMockExam/step1')
      },
      {
        path: 'step2',
        name: 'step2',
        component: () => import('@/views/RealMockExam/step2')
      },
      {
        path: 'step3',
        name: 'step3',
        component: () => import('@/views/RealMockExam/step3')
      },
      {
        path: 'step4',
        name: 'step4',
        component: () => import('@/views/RealMockExam/step4')
      }
    ]
  },
  //开始考试
  {
    path: '/:flag/doExam',
    name: 'DoExam',
    component: () => import('@/views/DoExam/index')
  },
  {
    path: '/:flag/analysis',
    name: 'analysis',
    meta: { title: '答案解析' },
    component: () => import('@/views/Analysis/index')
  },
  {
    path: '/:flag/mistakeRedo',
    name: 'mistakeRedo',
    meta: { title: '错题记录重做' },
    component: () => import('@/views/Analysis/mistakeRedo')
  },
  {
    //普通卷
    path: '/ordinaryExam',
    name: 'OrdinaryExam',
    component: () => import('@/views/OrdinaryExam')
  },
  {
    //开始按章练习
    path: '/:flag/doExamChapter',
    name: 'doExamChapter',
    component: () => import('@/views/DoExamChapter')
  }
];

const createRouter = () =>
  new Router({
    base: '/',
    routes: fixedRoutes
  });

const router = createRouter();

const routerPush = Router.prototype.push;
Router.prototype.push = function(location) {
  return routerPush.call(this, location).catch((error) => error);
};

//设置路由导航守卫
router.beforeEach((to, from, next) => {
  // to要去的页面 from从哪里来 next放行
  const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null;
  if (userID) {
    next();
  } else {
    Message.warning('未登录或登录已失效');
    //弹窗登录
    window.CDEL.ucLogin();
  }
});

export default router;
